import { render, staticRenderFns } from "./DetailPurchaseReturn.vue?vue&type=template&id=140386ca"
import script from "./DetailPurchaseReturn.vue?vue&type=script&lang=js"
export * from "./DetailPurchaseReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports